import { useChannel } from "@/lib/channel";

// Renders on Lesson and CourseOutline pages while an admin is walking a
// draft course (?channel=draft). Task 8 makes the server honor the channel
// for admins only; this banner is the SPA-side signal that the content and
// quiz/exam state on screen are isolated from the live course.
export function DraftChannelBanner(): JSX.Element | null {
  const channel = useChannel();
  if (channel !== "draft") return null;
  return (
    <div
      role="status"
      className="mb-4 rounded-control border border-gold/40 bg-gold-soft/15 px-4 py-2 text-sm text-foreground"
    >
      Draft preview — content and scores are isolated from the live course.
    </div>
  );
}
